import { Grid } from '@mui/material';
import { theme } from 'shared/theme';
import styled from 'styled-components';

export const GridContainer = styled(Grid)`
  background: rgba(80, 130, 201, 0.05);
  border: 2px dashed ${theme.colors.TextGrey};
  padding: 20px 30px;
`;
